import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { firestore, storage } from './firebase';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import './WorkerDashboard.css';

const WorkerDashboard = () => {
  const navigate = useNavigate();
  const [menuImage, setMenuImage] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('workerLoginName')) {
      navigate('/');                   
    }
  }, [navigate]);

  useEffect(() => {
    const fetchMenuImage = async () => {
      const docRef  = doc(firestore, 'menu', 'weeklyMenu');
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setMenuImage(docSnap.data().imageUrl);
      }
    };
    fetchMenuImage();
  }, []);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const storageRef = ref(storage, 'weeklyMenu');
    setIsUploading(true);

    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      'state_changed',
      () => {},
      (error) => {
        console.error('Upload failed:', error);
        setIsUploading(false);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setDoc(doc(firestore, 'menu', 'weeklyMenu'), { imageUrl: downloadURL });
          setMenuImage(downloadURL);
          setIsUploading(false);
        });
      }
    );
  };

  return (
    <div className="container-dashboard fade-in">
      <div className="menu-section">
        <h2>Wochenmenü</h2>

        <label className="upload-button">
          <input
            type="file"
            accept="image/*"
            onChange={handleImageUpload}
            disabled={isUploading}
            style={{ display: 'none' }}
          />
          Menübild wechseln
        </label>

        {isUploading ? (
          <p>Wird hochgeladen...</p>
        ) : (
          menuImage && (
            <img
              src={menuImage}
              alt="Wochenmenü"
              className={`menu-image ${imageLoaded ? 'menu-image-loaded' : ''}`}
              onLoad={() => setImageLoaded(true)}
            />
          )
        )}
      </div>
    </div>
  );
};

export default WorkerDashboard;
